<template>
    <Head>
        <title>Wakaf Pahang - Sunting kod bank</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <section ref="header" class="container-fluid py-3 position-fixed top-0 bg-wakaf-primary" style="z-index: 5">
        <div class="row">
            <h1 class="fs-3 text-center text-white" >Sunting kod bank Wakaf</h1>
        </div>
    </section>
    <section ref="body" class="container-fluid">
        <div class="row">
            <div class="d-flex w-auto">
                <div class="d-flex align-items-center">
                    <Link replace class="btn btn-warning" :href="uri_main"><font-awesome-icon :icon="faChevronLeft" /></Link>
                </div>
                <div class="col-md-12 ms-2">
                    <div class="d-flex flex-column">
                        <span class="fs-4 fw-bold">Sunting kod bank wakaf</span>
                        <span class="fs-6">Sunting maklumat yang perlu sahaja </span>
                        <span v-if="!isEmpty($page.props.errors)" class="fs-6 text-danger fw-bold mt-3">Sila penuhi syarat berikut: </span>
                        <ul v-if="!isEmpty($page.props.errors)" class="fs-6 text-danger fw-bold">
                            <li v-for="error in $page.props.errors">{{ error }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="row justify-content-center">
                <form @submit.prevent="formSend">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="kodbank" class="form-label">Kod bank</label>
                                <input type="text" class="form-control" id="kodbank" v-model="kodBank.kod" placeholder="Kod bank">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="keterangan" class="form-label">Keterangan kod bank</label>
                                <input type="text" class="form-control" id="keterangan" v-model="kodBank.keterangan" placeholder="Keterangan kod bank">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="bank" class="form-label">Bank</label>
                                <select class="form-select" id="bank" v-model="kodBank.bank">
                                    <option selected disabled value="0">Sila pilih</option>
                                    <option v-for="bankk in bank" :value="bankk.ID">{{ bankk.NamaBank }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button type="submit" :disabled="isSending" class="btn btn-primary float-end"><font-awesome-icon :icon="faRotate" /> Kemaskini</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import {Head, Link, router} from "@inertiajs/vue3";
import { RequestPayload } from "@inertiajs/core";
import Swal from "sweetalert2";
import {faChevronLeft, faPlus, faRotate} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
library.add(faChevronLeft, faRotate);

const data = defineProps<{
    csrf: string,
    img_favicon: string,
    uri_main: string,
    kodBankData: Data,
    uri_update: string,
    bank: {
        ID: number,
        NamaBank: string
    }[],
}>();

const header: Ref = ref<HTMLDivElement>();
const body: Ref = ref<HTMLDivElement>();
const isSending: Ref = ref<boolean>(false);

interface Data{
    id: number,
    kod: string,
    keterangan: string,
    TarikhDaftar: string,
    TarikhKemaskini: string,
    bank_id: number,
}

const kodBank = ref<{
    kod: string,
    keterangan: string,
    bank: number
}>({
    kod: "",
    keterangan: "",
    bank: 0,
});

onMounted(() => {
    body.value.style.marginTop = header.value.clientHeight+10 +"px";
    window.addEventListener("resize", ()=>{
        body.value.style.marginTop = header.value.clientHeight+10 +"px";
    });
    kodBank.value.kod = data.kodBankData.kod;
    kodBank.value.keterangan = data.kodBankData.keterangan;
    kodBank.value.bank = data.kodBankData.bank_id;
});

const formSend = (): void => {
    if(!formValidation()){
        Swal.fire({
            position: "center",
            icon: "error",
            title: "Maklumat tidak sah atau lengkap",
            showConfirmButton: true,
            confirmButtonText: "Ok"
        });
        return;
    }
    let postData: {
        nama: string,
        keterangan: string,
        bank: number,
    } = {
        nama: kodBank.value.kod,
        keterangan: kodBank.value.keterangan,
        bank: kodBank.value.bank,
    };

    //const formProjek = postData as unknown;
    router.patch(data.uri_update, postData as RequestPayload,{
        onError: () => {
            isSending.value = false;
            //console.log(page);
        }
    });
}

const formValidation = (): boolean =>{
    let isPassValidation: boolean = true;
    if(kodBank.value.kod.length < 0 || kodBank.value.kod.length >= 20){
        isPassValidation = false;
    }
    if(kodBank.value.keterangan.length <= 5 || kodBank.value.keterangan.length > 80){
        isPassValidation = false;
    }
    if(kodBank.value.bank === 0){
        isPassValidation = false;
    }
    // Date to is not validated here due to unknown end date by default

    return isPassValidation;
}

const isEmpty = (obj: Object): boolean => {
    return Object.keys(obj).length === 0;
}

</script>

<style scoped>

</style>
